import { CONTRACT_PROGRESS_CREDENTIALS_UPDATE } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressDocumentIdState = string | null;
const initialState: ContractProgressDocumentIdState = null;

export default function reducer(
  state: ContractProgressDocumentIdState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CREDENTIALS_UPDATE:
      return action.payload.documentId;
    default:
      return state;
  }
}
